export default "__VITE_ASSET__m2s4Ioz7__"